module.exports = "<!-- ko if: item.visible -->\n<!-- ko component: { name: item.componentName, params: { model: item.model } } -->\n<!-- /ko -->\n<!-- /ko -->";